import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';
import { ExerciseModel, ProblemProgressModel } from '..';

class ExerciseProgressModel extends BaseModel {

  id: number = undefined;
  exerciseId: number = undefined;
  isComplete: boolean = undefined;
  playedPersistence: number = undefined;
  openAnswer: string = undefined;

  @JsonProperty({ clazz: ExerciseModel })
  exercise: ExerciseModel = undefined;

  @JsonProperty({ clazz: ProblemProgressModel })
  problemProgress: ProblemProgressModel[] = undefined;
}

export { ExerciseProgressModel };
